import { PrintInvoicesSection } from 'src/features/supplier/components/PrintInvoicesSection'
import * as S from './PrintInvoicesPage.styles'
import { useState } from 'react'
import { Typography } from '@mui/material'
import { actions as swapOrReturnActions } from '../../SwapOrReturnState'
import { actions as receivementActions } from '../../../receivement/ReceivementState'
import { useDispatch } from 'react-redux'
import { useSelector } from 'src/utils/store'
import { PendingData } from '../../SwapOrReturnTypes'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'

export enum PrintInvoicePageModeEnum {
  RECEIVEMENT,
  PENDINGS
}

interface PrintInvoicesPageProps {
  mode: PrintInvoicePageModeEnum
}

export const PrintInvoicesPage = ({ mode }: PrintInvoicesPageProps) => {
  const { pendingsToPrint } = useSelector((state) => state.swapOrReturn)

  const history = useHistory()

  const dispatch = useDispatch()

  const [currentPendingIndex, setCurrentPendingIndex] = useState(0)

  const onConfirmSuccess = (pending: PendingData) => {
    if (pendingsToPrint) {
      if (mode === PrintInvoicePageModeEnum.RECEIVEMENT) {
        if (pending.idReceivement) {
          const onSuccess = () => {
            dispatch(swapOrReturnActions.setPendingToPrintAsDone(pending))
            toast.success('Recebimento liberado com sucesso!')
            history.push('/')
          }

          dispatch(receivementActions.releaseReceivementSwapReturn({
            idReceivement: pending.idReceivement,
            onSuccess,
          }))
        } else {
          toast.error('Erro ao liberar recebimento, pendência sem id do recebimento!')
        }
      } else if (mode === PrintInvoicePageModeEnum.PENDINGS) {
        if (pending.idRequest) {
          const onSuccess = () => {
            dispatch(swapOrReturnActions.setPendingToPrintAsDone(pending))
            toast.success('Pendência concluída com sucesso!')
          }

          dispatch(swapOrReturnActions.releaseReturnRequest({
            idRequest: pending.idRequest,
            onSuccess,
          }))
        } else {
          toast.error('Erro ao concluir pendência, id da pendência não encontrado!')
        }
      }
    }
  }

  const previousAction = () => {
    if (currentPendingIndex > 0) {
      setCurrentPendingIndex(currentPendingIndex - 1)
    }
  }

  const nextAction = () => {
    if (pendingsToPrint && currentPendingIndex < pendingsToPrint.pendings.length - 1) {
      setCurrentPendingIndex(currentPendingIndex + 1)
    }
  }

  const finishAction = () => {
    if (mode === PrintInvoicePageModeEnum.PENDINGS) {
      const idReceivementFromFinish = localStorage.getItem('idReceivementFromFinish')
      if (idReceivementFromFinish) {
        history.push(`/receivement/${idReceivementFromFinish}/finish`)
      } else {
        history.push('/')
      }
    } else {
      history.push('/')
    }
  }

  return (
    <S.Wrapper>
      {(pendingsToPrint && pendingsToPrint.pendings.length > 0) && (
        <>
          <S.BoxHeader>
            <Typography variant='h6' fontWeight='bold'>Fornecedor: {pendingsToPrint.supplierName}</Typography>
            <S.CustomButton
              title='Finalizar'
              type='button'
              onClick={finishAction}
              bgColor='darkBlue'
              hoverColor='darkBlueHover'
              letterColor='white'
              testId='finish-button-test-id'
              disabled={!pendingsToPrint.pendings.every((pending) => pending.done)}
            />
          </S.BoxHeader>
          {mode === PrintInvoicePageModeEnum.PENDINGS && (
          <S.NavigateInfo variant='h6' fontWeight='bold'>{currentPendingIndex + 1} / {pendingsToPrint.pendings.length}</S.NavigateInfo>
          )}
          {pendingsToPrint.pendings[currentPendingIndex].done
            ? (<S.DoneInfo variant='h6' fontWeight='bold'>Nota de devolução concluida</S.DoneInfo>)
            : (<PrintInvoicesSection dataToPrint={pendingsToPrint.pendings[currentPendingIndex]} onConfirmSuccess={onConfirmSuccess} />)}
          {mode === PrintInvoicePageModeEnum.PENDINGS && (
          <S.BoxNavigation>
            <S.CustomButton
              title='Anterior'
              type='button'
              onClick={previousAction}
              bgColor='darkBlue'
              hoverColor='darkBlueHover'
              letterColor='white'
              testId='previous-button-test-id'
              disabled={currentPendingIndex === 0}
            />
            <S.CustomButton
              title='Próximo'
              type='button'
              onClick={nextAction}
              bgColor='darkBlue'
              hoverColor='darkBlueHover'
              letterColor='white'
              testId='next-button-test-id'
              disabled={currentPendingIndex === pendingsToPrint.pendings.length - 1}
            />
          </S.BoxNavigation>
          )}
        </>
      )}
    </S.Wrapper>
  )
}
